import React, { useContext, useEffect, useRef } from 'react'
import Header from '@views/Header'
import Panels from '@views/Panels'
import Popups from '@views/Popups'
import Toasts from '@views/Toasts'
import ConfirmationDialog from '@components/ConfirmationDialog'
import { AppContext } from '@state/context'
import { setMainElement } from '@state/actions/appActions'
import { useCurrentUser } from '@hooks/useCurrentUser'
import { USER_ROLES } from '@helpers/constants'

const Layout = ({ children }) => {
  const mainRef = useRef()
  const [, dispatch] = useContext(AppContext)

  const { currentUser } = useCurrentUser()

  useEffect(() => {
    dispatch(setMainElement(mainRef.current))
  }, [mainRef.current])

  return (
    <>
      {/* Perhaps this should be named Header? */}
      <Header />

      <div className={'h-[calc(100vh - 80px)]'}>
        <main
          ref={mainRef}
          className={'pt-[80px] absolute inset-0 overflow-y-auto'}
        >
          {children}
        </main>
      </div>

      {/* And Footer of some sort should be done */}
      {/* <Footer /> */}
      <ConfirmationDialog />
      <Panels />
      {currentUser?.userRole !== USER_ROLES.STUDENT && <Popups />}
      <div id={'image-portal'} />
      <Toasts />
    </>
  )
}

export default Layout
